import styled from "styled-components";
import * as colors from "../config/colors";

const COLLAPSE_MS = "220ms";
const EASE = "cubic-bezier(0.2, 0, 0, 1)";

export const Shell = styled.div`
  position: relative; /* ancora o CollapseToggle do AppShell */
  min-height: 100vh;
  width: 100%;
  background: ${({ theme }) => theme.colors.appBackground};
  display: grid;

  grid-template-columns: auto 1fr;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const SidebarArea = styled.aside`
  height: 100vh;
  position: sticky;
  top: 0;

  overflow-y: auto;
  overflow-x: visible; /* permite o botão flutuante aparecer fora da borda */

  background: ${({ theme }) => theme.colors.appBackground};

  width: ${(p) => (p.$collapsed ? "72px" : "260px")};
  transition: width ${COLLAPSE_MS} ${EASE};
  will-change: width;

  @media (max-width: 900px) {
    position: fixed;
    top: 0;
    left: 0;

    width: min(82vw, 320px);
    height: 100vh;
    z-index: 50;
    overflow-x: hidden; /* no mobile volta a esconder */

    transform: translateX(${(p) => (p.$open ? "0" : "-110%")});
    transition: transform 0.15s ease;
  }
`;

export const MainArea = styled.main`
  min-width: 0;
  width: 100%;
  padding: 0;
  background: linear-gradient(135deg, ${colors.primaryDarkColor} 0%, #595959 100%);
`;

export const Topbar = styled.header`
  display: none;

  @media (max-width: 900px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    position: sticky;
    top: 0;
    z-index: 10;

    background: ${({ theme }) => theme.colors.appBackground};
    color: ${({ theme }) => theme.colors.textOnAppBackground ?? "#fff"};
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.borderOnAppBackground ?? "rgba(255, 255, 255, 0.08)"};
  }
`;

export const TopbarTitle = styled.div`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textOnAppBackground ?? "#fff"};
`;

export const IconButton = styled.button`
  background: transparent !important;
  color: ${({ theme }) => theme.colors.textOnAppBackground ?? "#fff"} !important;
  padding: 8px 10px !important;
  border: 1px solid
    ${({ theme }) => theme.colors.controlBorderOnAppBackground ?? "rgba(255, 255, 255, 0.14)"} !important;
  border-radius: 8px !important;

  &:hover {
    background: ${({ theme }) => theme.colors.controlHoverOnAppBackground ?? "rgba(255, 255, 255, 0.08)"} !important;
  }
`;

export const Overlay = styled.div`
  display: none;

  @media (max-width: 900px) {
    display: ${(p) => (p.$open ? "block" : "none")};
    position: fixed;
    inset: 0;
    z-index: 40;
    background: ${({ theme }) => theme.colors.backdrop ?? "rgba(0, 0, 0, 0.35)"};
  }
`;
